/**
 * Generates a pseudo-random string identifier.
 *
 * @returns {string} A random alphanumeric string of 7 characters.
 *
 * @remarks
 * This function uses `Math.random()` and base-36 encoding to create a short, non-cryptographically secure ID.
 */
export const makeId = (): string => {
  return Math.random().toString(36).slice(2, 9);
};
